import { createApp, markRaw, watch } from "vue";
import VueApexCharts from 'vue3-apexcharts';
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";
import createPersistedState from "pinia-plugin-persistedstate";
import { plugin, defaultConfig } from "@formkit/vue";
import configformKit from "../formkit.config.js";
import "@/scss/styles.scss";
import * as bootstrap from "bootstrap";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import App from "./App.vue";
import router from "@/router";
import axios from "axios";
import Swal from "sweetalert2";
import Pusher from "pusher-js";
import { authChannel } from "@/utils/authChannel";
import es from "./locales/es.json";
import en from "./locales/en.json";
import { initDelegatedTooltips } from "./plugins/boostrap-tooltips.js";
import { useAuthStore } from "@/stores/auth.js";
import { useDeviceStore } from "./stores/device.js";

initDelegatedTooltips();

window.bootstrap = bootstrap;

window.axios = axios;

window.axios.defaults.baseURL = import.meta.env.VITE_API_URL;
window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.defaults.headers.common["Content-Type"] = "aplication/json";
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;

window.swal = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-success float-end",
    cancelButton: "btn btn-danger mx-3",
  },
  color: "var(--bs-body-color)",
  background: "var(--bs-body-bg)",
  buttonsStyling: false,
});

const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(router);
});
pinia.use(createPersistedState);
const app = createApp(App);

app
  .component
  // // the registered name
  // 'MyComponent',
  // // the implementation
  // {
  //   /* ... */
  // }
  ();

/*MANEJO DE ERRORES */
app.config.errorHandler = (err, vm, info) => {
  console.error("Error:", err);
  console.error("Vue component:", vm);
  console.error("Additional info:", info);
};

const i18n = createI18n({
  legacy: false, // 🚨 importante: desactiva el Legacy API
  locale: "es",
  fallbackLocale: "en",
  messages: {
    es,
    en,
  },
});
app.use(i18n);

const options = {
  position: POSITION.BOTTOM_RIGHT,
  pauseOnHover: true,
  showCloseButtonOnHover: true,
};
app.use(Toast, options);
app.use(pinia);
app.use(VueApexCharts);
//sockect
const authStore = useAuthStore();
window.Pusher = Pusher;

const deviceStore = useDeviceStore();
await deviceStore.init();

watch(
  () => authStore.token,
  (newToken) => {
    if (newToken) {
      authStore.initializeEcho();
    } else if (authStore.echo) {
      authStore.echo.disconnect();
    }
  }
);

// Si el usuario ya tiene sesión iniciada, inicializar Echo
if (authStore.token) {
  authStore.initializeEcho();
}

authChannel.onmessage = (event) => {
  if (event.data.type === "logout") {
    const auth = useAuthStore();

    if (auth.authToken || auth.authUser) {
      console.log("🔄 Sesión cerrada desde otra pestaña");
      auth.logout();
    }
  }
};

// window.addEventListener("storage", (event) => {
//   if (event.key === "logout") {
//     const auth = useAuthStore();

//     if (auth.token || auth.authUser) {
//       auth.logout();
//     }
//   }
// });

app.use(plugin, defaultConfig(configformKit));
app.use(router);

app.mount("#app");
